<template>
  <div style="background-color: rgb(255,255,255)">
    <el-row style="min-width: 1500px">
<!--      <el-col :span="6" style="min-width: 500px;padding-left: 15.5%" v-sticky="{ zIndex: 100, stickyTop: 50, disabled:false}">
        <div class="content">
          <p class="titleimg" style="border-bottom: 2px solid #2A67E3;line-height: 50px;color: #2A67E3;margin: 20px 5px 0 5px;font-weight: bold">产品演示</p>
          <div class="titleimg"
             v-for="(item,index) in contentList"
             :key="index"
             @click="clickNavigation(item)"
             :class="{titleimg2:item.columnText===styleName}">
            <div style="display: flex;justify-content: center;align-items: center">
              <span  style="width: 90%">{{item.columnText}}</span>
              <img class="image" src="../../assets/scheme/Page3.png" alt="" v-show="item.columnText===styleName"
                   style="width: 6px;height: 8px">
            </div>
          </div>
        </div>
      </el-col>-->
      <el-col :span="15" :offset="3">
        <el-row style="margin-left: 40px">
          <div class="nav">
            <div class="box-big">
              <template>
                <div class="top-title">
                  <p class="title">产品</p>
                  <div class="border"></div>
                </div>
                <div class="text">
                  <div  v-for="item in productList">
<!--                    v-if="item.type==styleName"-->
                    <div class="product" :class="{disabled:item.disabled}"  >
                      <div class="product-img" @click="jump(item)">
                        <img class="image" :src="item.img" alt="">
                      </div>
                      <div class="product-content" @click="jump(item)" v-if="item.name!='数字藏品'">
                        <template>
                          <span class="product-title">{{ item.name }}</span>
                          <span class="product-options">{{ item.text }}</span>
                        </template>
                      </div>
                      <div class="product-content" v-else>
                        <template>
                          <span class="product-title">{{ item.name }}</span>
                          <div class="product-optionsnum">
                            <div v-for="val in item.url" :key="val.textname" @click="jump(item,val)">{{ val.textname }}</div>
                          </div>
                        </template>
                      </div>

                    </div>
                  </div>
<!--                  <div class="product" :class="{disabled:true}"  v-if="styleName!='演示资源'">
                    <div class="product-img">
                      <img class="image" :src="require('../../assets/demonstration/logo3.png')" alt="">
                    </div>
                    <div class="product-content">
                      <template>
                        <span class="product-title">敬请期待</span>
                        <span class="product-options">开发中</span>
                      </template>
                    </div>
                  </div>-->
                </div>
              </template>
            </div>
          </div>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import img1 from "../../assets/demonstration/logo.png"
import img2 from "../../assets/demonstration/logo1.png"
import img3 from "../../assets/demonstration/logo5.png"
import img4 from "../../assets/demonstration/logo4.png"
import img5 from "../../assets/demonstration/logo6.png"
import img6 from "../../assets/demonstration/logo3.png"
import img7 from "../../assets/demonstration/img.png"
import img8 from "../../assets/demonstration/img1.png"
import axios from "axios";
import VueSticky from "vue-sticky";

export default {
  name: "product.vue",
  data() {
    return {
      styleName: "",
      contentList: [],
      styleIndex: 0,
      productList: [
        {name: '兆票', text: "区块链供应链金融平台", img: img1, url: "http://mtf.trilliontrust.com/",type:"区块链应用平台"},
        {name: '兆融', text: "区块链数据价值融通服务平台", img: img2, url: "http://contract.trilliontrust.com/",type:"区块链应用平台"},
        {name: '兆存', text: "区块链数据存证平台", img: img5, url: "http://profile.trilliontrust.com/",type:"区块链应用平台"},
        {name: '智信链+', text: "区块链BAAS平台V4.0", img: img5, url: "http://mt.trilliontrust.com/",type:"区块链平台"},
        {name: '智信链+', text: "区块链BAAS平台V3.0", img: img5, url: "http://baas.chenhaninfo.com/",type:"区块链平台"},
        {name: '智信链+', text: "区块链BAAS平台V2.0", img: img5, url: "http://dmgmt.trilliontrust.com/",type:"区块链平台"},
        {name: 'MPDM', text: "区块链隐私计算数据服务平台", img: img4, url: "http://mpdatatrading.trilliontrust.com/",type:"隐私计算平台"},
        {name: 'MPDI', text: "区块链隐私计算数据服务管理平台", img: img4, url: "http://mpdatatrading-admin.trilliontrust.com/",type:"隐私计算平台"},
        {name: 'StorNet', text: "区块链分布式存储网络", img: img4, url: "http://dstorenet.trilliontrust.com/",type:"区块链平台"},
        {
          name: '铁证网',
          text: "一站式电子证据平台",
          img: img2,
          url: "http://www.tiezhengwang.com/",
          routerName: "hncrpt",
          type:"区块链应用平台",
        },
        {name: '智能体', text: "数据智能信息系统", img: img4, url: "http://info.trilliontrust.com/",type:"群体智能"},
        {name: '舆情', text: "舆情监测平台", img: img2, url: "http://yuqing.chenhaninfo.com/",type:"群体智能"},
        // {name: 'MT大屏演示', text: "国产自主可控高性能", img: img3, url: ""},
        {name: '兆训', text: "区块链教学实训平台", img: img8, url: "http://mttrain.trilliontrust.com/",type:"区块链应用平台"},
        {name: '演示资源下载', text: "产品演示资源", img: img5, url: 'http://files.trilliontrust.com/演示文档数据地址.docx',type:"演示资源"},
        {name: '数字藏品', text: '', img: img4, url: [{textname:'管理端',texturl:'https://pk-admin.trilliontrust.com/'},{textname:'h5',texturl:'https://pk-h5.trilliontrust.com/pages/home/home'}],type:"区块链应用平台"},
      ],

    }
  },
  directives: {
    'sticky': VueSticky,
  },
  created() {
    this.getList()
  },
  methods: {

    clickNavigation(item){
      this.styleName = item.columnText
    },
    getList(item){
      axios.get("https://article.chenhaninfo.com/publish-article/sys/column/columnList", {
      }).then(({data}) => {
        console.log(data)
        if (data && data.code === 0) {
          for(let item2 of data.list){
            if(item2.columnText === '区块链产品演示'){
              this.contentList = item2.list
              this.styleName==""?this.styleName=this.contentList[0].columnText:null
              this.getText()
            }
          }
        } else {
        }
      }).catch(function (error) {
        console.log(error);
      })
    },
    jump(item,val) {
      let url = item.url
      if (url) {
        if (item.name == '演示资源下载') {
          console.log(item)
          // url = url.replace('http','https')
          window.open(url, "_self")
        }else if(item.name == '数字藏品'){
          if(val){
            window.open(val.texturl, "_blank")
          }else{
            url = 'https://pk-admin.trilliontrust.com/'
            window.open(url, "_blank")
          }
        }else {
          window.open(url, "_blank")
        }
      } else {
        this.$router.push({name: item.routerName})
      }
    },
  }
}
</script>

<style scoped lang="scss">


.content {
  width: 245px;
  /*height: 265px;*/
  background: #FAFBFC;
  border-radius: 5px;
  border: 1px solid #D9E9FF;
  margin-top: 36px;
  margin-bottom: 35px;
  padding-bottom: 44px;
  .image {
    float: right;
    position: relative;
    top: 8px;
    right: 20px;
  }
}

.titleimg {
  cursor: pointer;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 25px;
  text-align: center;
  margin-top: 44px;
}

.titleimg2 {
  color: #2A67E3
}
.nav {
  padding: 0px 40px;
  margin-top: 13px;

  .box-big {
    width: 80%;
    //margin-left: 10%;
  }

  .top-title {
    padding-top: 82px;

    .title {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 700;
      color: #282F3C;
      margin-left: 52px;
      margin-top: -19px;

    }

    .border {
      width: 27px;
      height: 3px;
      margin-top: 3px;
      background-color: #056DFF;
      margin-left: 41px;
    }
  }

  .text {
    display: flex;
    flex-wrap: wrap;
    min-width: 1340px;
    margin-left: -6px;
    /*margin-left: 100px;*/
    .product {
      width: 385px;
      height: 150px;
      //background: #FAFBFC;
      border-radius: 5px;
      cursor: pointer;
      margin: 20px 30px;

      .product-img {
        width: 75px;
        height: 75px;
        background: #F1F3F8;
        border-radius: 50%;
        margin: 17px 0px 18px 22px;

        .image {
          position: relative;
          top: 31%;
          left: 26%;
          width: 35px;
          height: 32px;
        }
      }
    }

    .disabled {
      cursor: no-drop;
    }


    .product-content {
      display: flex;
      flex-wrap: wrap;
      margin-left: 23px;
      margin-top: -30px;
      position: relative;

      .product-options-shelves {
        width: 158px;
        height: 33px;
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #999999;
        line-height: 33px;
        position: absolute;
        bottom: 30px;
        left: 150px;
      }

      .product-title {
        //width: 48px;
        height: 33px;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #2A67E3;
        line-height: 33px;
        text-decoration: none;
        position: absolute;
        bottom: 28px;
        left: 30%;
      }

      .product-options {
        width: 126px;
        height: 30px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 20px;
        text-decoration: none;
        position: absolute;
        bottom: -10px;
        left: 30%;
      }
      .product-optionsnum {
        // width: 126px;
        // height: 30px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 20px;
        text-decoration: none;
        // display: inline-block;
        position: absolute;
        bottom: -18px;
        left: 30%;
      }
    }
  }
}
</style>
